const META_PIXEL_ID = "1784624072279856";
const GA_ID = process.env.REACT_APP_GA_ID;
let pixelLoaded = false;
let gaLoaded = false;

function hasConsent() {
  return localStorage.getItem("brimo_cookie_consent") === "accepted";
}

export function initTracking() {
  if (!hasConsent()) return;

  // Load Meta Pixel
  if (!pixelLoaded) {
    pixelLoaded = true;
    !function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)
    }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }

  // Load Google Analytics 4
  if (!gaLoaded && GA_ID) {
    gaLoaded = true;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }
}

export function revokeTracking() {
  // Revoke Meta Pixel
  if (window.fbq) {
    window.fbq('consent', 'revoke');
  }
  document.cookie.split(";").forEach((c) => {
    const name = c.trim().split("=")[0];
    if (name.startsWith("_fb") || name.startsWith("_fbc")) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    }
  });

  // Revoke Google Analytics
  if (GA_ID) {
    window[`ga-disable-${GA_ID}`] = true;
  }
  document.cookie.split(";").forEach((c) => {
    const name = c.trim().split("=")[0];
    if (name.startsWith("_ga") || name.startsWith("_gid") || name.startsWith("_gat")) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    }
  });

  pixelLoaded = false;
  gaLoaded = false;
}

export function trackPageView() {
  if (!hasConsent()) return;

  // Meta Pixel
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }

  // Google Analytics
  if (window.gtag && GA_ID) {
    window.gtag('event', 'page_view', {
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}

export function trackLead(data = {}) {
  if (!hasConsent()) return;

  // Meta Pixel
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: data.lead_type || 'contact',
      content_category: data.page_source || 'unknown',
      value: 0,
      currency: 'EUR',
    });
  }

  // Google Analytics
  if (window.gtag) {
    window.gtag('event', 'generate_lead', {
      event_category: data.lead_type || 'contact',
      event_label: data.page_source || 'unknown',
    });
  }
}

export function trackContact() {
  if (!hasConsent()) return;
  if (window.fbq) {
    window.fbq('track', 'Contact');
  }
  if (window.gtag) {
    window.gtag('event', 'contact', { method: 'form' });
  }
}

export function trackCustom(eventName, data = {}) {
  if (!hasConsent()) return;
  if (window.fbq) {
    window.fbq('trackCustom', eventName, data);
  }
  if (window.gtag) {
    window.gtag('event', eventName, data);
  }
}
